import { Badge } from "primeng/badge";

export const SIDE_MENU_CONSTANTS: any = {
    MENU_ITEMS: [
        {
            label: 'Home',
            icon: 'home',
            link: 'landing',
            resourceName : 'Kavach',
            resourceTypeName: 'Application',
        },
        // ===== BEGIN Export-DWG feature menu item =====
        {
            label: 'CAD',
            icon: 'app-window',
            link: 'export-dwg',
            resourceName : 'Cad',
            resourceTypeName: 'Dashboards',
        },
        // ===== END Export-DWG feature menu item =====
        {
            label: 'Layout PDF Comparison',
            icon: 'file-diff',
            link: 'pdf-layout-diff',
            resourceName : 'Kavach',
            resourceTypeName: 'Application',
            nonProdOnly: true, // hidden from the sidebar when environment.production is true
        },
        //  {
        //     label: 'Zone Rules',
        //     icon: 'book-2',
        //     link: 'zone-rules',
        //     resourceName : 'Kavach',
        //     resourceTypeName: 'Application',
        // },
        {
            label: 'Organizations',
            icon: 'building',
            link: 'usermgmt/customer',
            resourceName : 'User Management',
            resourceTypeName: 'Application',
        },
        {
            label: 'Applications',
            icon: 'layout-2',
            link: 'usermgmt/applications',
             resourceName : 'User Management',
            resourceTypeName: 'Application',
        },
        {
            label: 'Roles',
            icon: 'key',
            link: 'usermgmt/roles',
             resourceName : 'User Management',
            resourceTypeName: 'Application',
        },
        {
            label: 'Users',
            icon: 'users',
            link: 'usermgmt/users',
             resourceName : 'User Management',
            resourceTypeName: 'Application',
        },
        {
            label: 'Layout Logs',
            icon: 'file-diff',
            link: 'layout-logs',
            resourceName : 'Kavach',
            resourceTypeName: 'Application',
        },
        
    ]
}